import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import Image from '../../../components/UI/Image';
import styles, { best, hover, item, title, sectionTitle, wrapper } from './Best.module.css';
import { arrayOf, object, func } from 'prop-types';

const Best = ({ items, onItemSelected }) => (
  <section className={best}>
    <Container>
      <div className={`${sectionTitle} title`}>Our best</div>
      <Row>
        <Col lg={{ size: 10, offset: 1 }}>

          <div className={wrapper}>
            {items.map(({ name, url, price, id }) => {
              return (
                <div className={`${item} ${hover}`} key={id} onClick={() => onItemSelected(id)}>
                  <Image src={`${url}`} alt="coffee" />
                  <div className={title}>
                    {name}
                  </div>
                  <div className={styles.price}>{price}</div>
                </div>
              )
            })}
          </div>
        </Col>
      </Row>
    </Container>
  </section>
)

Best.propTypes = {
  items: arrayOf(object),
  onItemSelected: func,
}

Best.defaultProps = {
  items: [{}],
  onItemSelected: () => { },
}

export default Best 